import script from "./InputComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputComponent.vue?vue&type=script&setup=true&lang=ts"

import "./InputComponent.vue?vue&type=style&index=0&id=293096b6&lang=scss"

const __exports__ = script;

export default __exports__